import { SparklesIcon } from 'lucide-react';

import { AnalysisSubHeader, TwoColumnProse } from '../../../../components';

import { StatistaChartCard } from '../StatistaCharts';

import type { MarketWhiteSpaceProps } from './MarketWhiteSpace.types';
import { useTranslation } from 'react-i18next';

export const MarketWhiteSpace = ({ whitespace, citedDatasets }: MarketWhiteSpaceProps) => {
  const { t } = useTranslation('analysis');

  if (!whitespace) return null;

  return (
    <div className="flex flex-col gap-6">
      <AnalysisSubHeader
        title={t('analysisResult.marketWhiteSpace.marketWhiteSpace')}
        subtitle={t('analysisResult.marketWhiteSpace.untappedOpportunityForGrowthAnd')}
        subtitleTone="meta"
      />
      <div className="flex flex-col items-start gap-3">
        <span className="inline-flex h-7 items-center gap-1.5 rounded-full bg-purple-100 px-3 text-body-md font-medium text-purple-800 dark:bg-badge-purple dark:text-badge-purple-foreground">
          <SparklesIcon className="size-3.5 shrink-0" />
          {t('analysisResult.marketWhiteSpace.keyOpportunities')}
        </span>
        <TwoColumnProse text={whitespace} />
      </div>
      {citedDatasets?.map((cited) => (
        <StatistaChartCard key={cited.id} dataset={cited} citedIn={whitespace} />
      ))}
    </div>
  );
};
